import React, { FC, useRef, useEffect, useState, useCallback } from "react";
import { createUseStyles } from "react-jss";

import RoadMap from "Assets/images/map_type_roadmap.svg";
import Satellite from "Assets/images/map_type_satellite.svg";
import GoogleMap from "../../map/GoogleMap";

import styles from "./styles";

interface Props {
  mapObj: any;
}

const MapType: FC<Props> = (props: Props) => {
  const { mapObj } = props;
  const mapTypeControl = useRef(null);
  const [mapType, setMapType] = useState("road");

  const useStyles = createUseStyles(styles);

  const classes = useStyles({ ...props });

  const changeMapType = useCallback(() => {
    if (mapType === "road") {
      setMapType("satellite");
      mapObj.setMapType(GoogleMap.MAP_TYPE.SATELLITE, []);
    } else {
      setMapType("road");
      mapObj.setMapType(GoogleMap.MAP_TYPE.ROADMAP, []);
    }
  }, [mapObj, mapType]);

  useEffect(() => {
    let mapTypeListener: any;

    if (mapObj) {
      const { addDomListener } = window.google.maps.event;
      mapTypeListener = addDomListener(
        mapTypeControl.current,
        "click",
        changeMapType
      );
    }
    return () => {
      if (mapTypeListener) mapTypeListener.remove();
    };
  }, [changeMapType, mapObj, mapType]);

  return (
    <button
      aria-label={`Switch map view to ${
        mapType === "road" ? "satellite" : "road"
      }`}
      type="button"
      className={classes.container}
      ref={mapTypeControl}
      data-testid="container"
    >
      {mapType === "road" ? <Satellite /> : <RoadMap />}
    </button>
  );
};

export default MapType;
